export const HAIRSP = ' ';
